import {Component, ViewChild} from '@angular/core';
import {Keyboard, NavController, NavParams, TextInput, ViewController} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {TAction} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {DataService} from '../../../providers/data-service';



@Component({
    selector: 'page-showfila',
    templateUrl: 'showfila.html',
    providers: [],
})
export class ShowfilaPage {

    TAction: any = TAction;

    config: any;

    etapa: number;
    hotspot: any;
    comanda: any;
    message: string;
    taptext: string;
    fliprun: boolean;
    running: boolean;

    hotspotID: number;
    intervalID: number;

    paused: boolean;
    timeset: string;
    timenow: Date;
    timeout: number;
    blink: boolean;

    @ViewChild('inputCheckin') inputCheckin: TextInput;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util, public keyboard: Keyboard, public logadoService: LogadoService,
                public dataService: DataService) {

        this.config = CONFIG;

        this.intervalID = 0;

        this.paused = false;
        this.timeset = '00:02:00';
        this.running = true;
        this.hotspotID = this.util.anyParams(0, this.dataService.get('param.hotspotid'));

        this.start();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showfila', '/showfila');

        this.prepareLoad();
        this.esperarStep(0, null, null, null);

        if (this.hotspotID) this.hotspotAuth('', this.hotspotID);
    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

        setTimeout(() => {
            if (this.inputCheckin) this.inputCheckin.setFocus();
        }, 800);

    }

    prepareLoad() {

        setInterval( () => {

            if (this.paused) return;


            this.blink = (this.timenow.getMinutes() == 0 && this.timenow.getSeconds() <= 10 && this.timenow.getSeconds() > 1);
            let finish = (this.timenow.getMinutes() == 0 && this.timenow.getSeconds() == 0);

            if (finish && this.timeout > 0) {
                this.timeout = this.timeout - 1;
                return;
            }

            if (finish && this.timeout == 0) this.start();
            if (!finish) this.timenow.setSeconds(this.timenow.getSeconds() - 1);

        }, 1000);

    }

    start() {

        let datestr = '2000-01-01 ' + this.timeset;
        this.timenow = new Date(datestr.replace(' ', 'T'));
        this.timeout = 5;

    }

    nowtime(time: string) {

        this.paused = true;
        this.timeset = time;
        this.start();

    }

    cancelaWait() {

        /** TIME **/
        let buttons: Array<any> = [];
        buttons.push({text: '2 minutos', handler: () => this.nowtime('00:02:00')});
        buttons.push({text: '3 minutos', handler: () => this.nowtime('00:03:00')});
        buttons.push({text: '5 minutos', handler: () => this.nowtime('00:05:00')});
        buttons.push({text: '10 minutos', handler: () => this.nowtime('00:10:00')});
        buttons.push({text: '15 minutos', handler: () => this.nowtime('00:15:00')});
        this.util.sheetOpen(buttons, 'TEMPO');

    }

    dismiss() {

        if (this.etapa == 1) {
            this.esperarStep(0, null, null, null);
            return;
        }

        if ( this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        if (!this.viewCtrl.isOverlay) this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    esperarStep(etapa, message, comanda, taptext) {

        this.etapa = etapa;
        this.message = message;
        if (this.etapa == 0) this.hotspot = null;
        this.comanda = comanda;
        this.taptext = (taptext || '');

        this.running = (this.etapa == 2) && !this.message;
        clearTimeout(this.intervalID);

        setTimeout(() => {
            if (this.inputCheckin) this.inputCheckin.setFocus();
        }, 800);

    }

    esperarTint(background : boolean = false) : string {

        if (background) {
            if (this.message) return 'CorFood';
            if (this.etapa == 0) return 'CorMilk';
            if (this.etapa == 1) return this.hotspot.Branded.BrandedCora;
            if (this.etapa == 2) return this.comanda.PaybookWalk ? 'CorMilk' : this.hotspot.Branded.BrandedCora;
        }

        if (this.etapa == 2) {
            if (this.message) return 'CorMilk';
            if (this.comanda.PaybookWalk) return 'CorRoxa';
            return this.config.negative(this.hotspot.Branded.BrandedCora);
        }

    }

    esperarLixo() {

        this.running = false;
        clearTimeout(this.intervalID);

        let onLoad = () => this.esperarCall(false, true);

        let onLixo = () => {

            let loading = this.util.loadingDots();
            loading.present();
    
            let params = '&ComandaID=' + this.comanda.ComandaID;
            this.util.monitorDesk(false, 'DESK-Started', 1050, params, TAction.acWait)
                .finally(() => loading.dismiss())
                .subscribe(data => {
    
                    this.esperarStep(0, null, null, null);
    
                }, erro => {
    
                    this.message = erro.Result;
                    this.comanda = null;
    
                });
    
        }

        let alerta = 'Deseja <b>CANCELAR</b> sua reserva?';
        this.util.alertQuestion('ATENÇÃO', alerta, 'Eu CONFIRMO', onLixo, false, true, 'alert-danger', onLoad);
    
    }

    hotspotAuth(codeday, hotspotID) {

        let onDone = (spot, erro) => {
            
            this.hotspot = spot;
            let etapa = (this.hotspot ? 1 : 0);

            this.esperarStep(etapa, erro, null, null);
            
        };

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&HotspotID=' + hotspotID + '&Codeday=' + codeday;
        this.logadoService.started(TAction.acWait, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(data.Hotspot, null),
                erro => onDone(null, erro.Result)
            )

    }

    bmaskerMask() {

        let text = (this.taptext || '');
        let rnid = (text && !isNaN(Number(text[0])));
        let size = text.replace('.', '').length;
        let mask = (size <= 4 ? '0000' : (size == 5 ? '00.000' : '000.000.000-00'));
        let tipo = 'num';

        //Aceita digitação de Workday
        if (!this.hotspot && !rnid) {
            let mesk = '';
            let bool = false;
            for (let index = 0; index <= text.length-1; index++) {
                if (text[index] != '-' && isNaN(Number(text[index]))) mesk += 'A';
                if (!isNaN(Number(text[index]))) {
                    bool = true;
                    break;
                }
            }
            mesk = mesk + '-000';
            mask = (bool ? mesk : 'AAAAAAAAAA');
            tipo = 'all';
        }

        return {mask: mask, type: tipo, len: mask.length};

    }

    bmaskerOpen() {

        //#GAMBI - Cardapio do Lorean Desk

        this.taptext = (this.taptext || '').toUpperCase();

        let array = this.taptext.split('-');
        let nick = (array[0] || '');
        let code = (array[1] || '');
        let work = (nick.length >= 3 && code.length == 3 && !this.hotspot);
        let rnid = this.util.validaCNPF(this.taptext);
        if (!rnid && !work) return;

        let texto = this.taptext;

        this.keyboard.close();
        this.keyboard.onClose(() => {

            if (work) {
                this.hotspot = null;
                this.hotspotAuth(texto, false);
                return;
            }

            if (rnid) {
                this.esperarCall(true, true);
            }

        });

    }


    esperarCall(isFirst = true, forceRun = false) {

        clearTimeout(this.intervalID);

        if (this.etapa == 0 && this.message) {
            this.esperarStep(0, null, null, null);
            return;
        }

        if (!this.util.validaCNPF(this.taptext)) {
            return;
        }

        if (!this.hotspot) {
            //onOkay para folocar o foco no input
            let onOkay = () => this.esperarStep(0, null, null, null);
            this.util.alertSimply('Informe o <b>código do lugar</b>!<br>Seu <b>CPF</b> será na próxima tela!<br><br>Pegue o código no estabelacimento', 'ATENÇÃO', 'OK, Entendi', false, null, onOkay);
            return;
        }

        this.esperarFila(isFirst, forceRun);

    }

    esperarFila(isFirst = true, forceRun = false) {

        let loading = this.util.loadingDots();
        if (isFirst) loading.present();

        let params = '&ProfileRnid=' + this.taptext;
        this.util.monitorDesk(false, 'DESK-Started', 1050, params, TAction.acFila)
            .finally(() => {
                if (isFirst) loading.dismiss();
            })
            .subscribe(data => {

                let etapa = (data.Comandas[0] ? 2 : 1);
                this.esperarStep(etapa, null, data.Comandas[0], this.taptext);

                this.fliprun = !this.fliprun;
                if (forceRun && this.comanda) this.running = true;
                if (this.running) this.intervalID = setTimeout(() => this.esperarFila(false), 5*1000);

                //this.startCounter();
                //this.stopCounter();

            }, erro => {

                if (this.message) {
                    this.esperarStep(1, null, null, null);
                    return;
                }

                this.esperarStep(this.etapa, erro.Result, null, this.taptext);
                //this.startCounter();
                //this.intervalID = setTimeout(() => this.load(false), 5*1000);

            });

    }


}



// WEBPACK FOOTER //
// ./src/pages/show/showfila/showfila.ts